import { MainContentLayout } from 'shared/ui/layout';

import { AddCarModel } from 'features/car/add-car-model';

export function AddCarModelPage() {
  return <MainContentLayout element={<AddCarModel />} />;
}
